Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "description2334784922",
  {"root":"description2334784922--root"},
  "",
  2,
  "description2334784922"
);

